.cal-container {
  padding-bottom: 20px;
}
.cal-title {
  display: flex;
}
.cal-title > *:first-child {
  margin-right: auto;
}
